// extracted by mini-css-extract-plugin
module.exports = {"root":"error-message_root__waHwb","icon":"error-message_icon__kx4iN","text":"error-message_text__5HirX"};